/** Formateadores de fecha e importe para la interfaz (castellano, Europa/Madrid). */

const LOCALE = "es-ES";

export const formatoFecha = (valor?: string | null): string => {
  if (!valor) return "";
  const d = /^\d{4}-\d{2}-\d{2}$/.test(valor)
    ? new Date(`${valor}T00:00:00`)
    : new Date(valor);
  if (Number.isNaN(d.getTime())) return valor;
  return new Intl.DateTimeFormat(LOCALE, {
    day: "numeric",
    month: "short",
    year: d.getFullYear() === new Date().getFullYear() ? undefined : "numeric",
  }).format(d);
};

export const formatoFechaHora = (valor?: string | null): string => {
  if (!valor) return "";
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return valor;
  return new Intl.DateTimeFormat(LOCALE, {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
};

export const formatoImporte = (valor?: number | null): string => {
  if (valor === null || valor === undefined || Number.isNaN(valor)) return "";
  return new Intl.NumberFormat(LOCALE, {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(valor);
};

const dos = (n: number) => String(n).padStart(2, "0");

/** Valor para <input type="datetime-local"> en hora local. */
export const aDatetimeLocal = (d: Date): string =>
  `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())}T${dos(d.getHours())}:${dos(d.getMinutes())}`;

/** De <input type="datetime-local"> (hora local) a ISO UTC. */
export const deDatetimeLocal = (valor: string): string | undefined => {
  if (!valor) return undefined;
  const d = new Date(valor);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
};

/** Iniciales de un nombre («Robert Carbajal» → «RC»). */
export const iniciales = (nombre?: string | null): string =>
  (nombre ?? "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
